import { PaperBlock } from 'packages/sdks-next/growp'
import React from 'react'
import { getSubQuestionsByParentId } from '../utils'
import { JudgeMode } from '@/features/test-paper/types'
import { SubFillInBlank } from './SubFillInBlank'
import { PaperQuestionWithReq } from '@/features/test-paper/components/Blocks/Question/EditQuestion/types'

export const FillInBlankAnswer: React.FC<{
  mainQuestion: PaperQuestionWithReq
  block: PaperBlock
}> = ({ mainQuestion, block }) => {
  const subQuestions = getSubQuestionsByParentId(
    block.questions || [],
    mainQuestion.id
  )
  const subQuestionNum = subQuestions.length
  const isAutoMode = mainQuestion.settings?.judgeMode !== JudgeMode.Manual
  return (
    <>
      {subQuestions.map((question, index) => {
        return (
          <React.Fragment key={question.id}>
            <SubFillInBlank
              mainQuestion={mainQuestion}
              curQuestion={question}
              block={block}
              index={index}
              subQuestionNum={subQuestionNum}
              isAutoMode={isAutoMode}
            />
          </React.Fragment>
        )
      })}
    </>
  )
}
